import React, { useEffect, useRef, useState } from "react";
import {
    Bar,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    ComposedChart,
    LabelList,
    Legend
} from "recharts";
import { PrAnalysisTab2Api } from "../../../../../../api/Api";
import { FaCrosshairs } from 'react-icons/fa';

import { AuthenticationContext } from "../../../../../../context/AuthenticationContext";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography,
    useTheme,
    CardActions,
    Button
} from "@mui/material";

import { PASS_KEY, WEB_KEY, BaseUrl } from '../../../../../../api/AxiosApi'
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";
import { Inverter1LogApi } from "../../../../../../api/Api";

// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD

    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

function SpareChart2({ ID, TabTitle }) {
    const chartRef = useRef();
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);
    const [loading, setLoading] = useState(false);
    const [chartData, setChartData] = useState([]);
    const [chartData2, setChartData2] = useState([]);
    const [chartData3, setChartData3] = useState([]);
    const [chartData4, setChartData4] = useState([]);
    const [chartData5, setChartData5] = useState([]);
    const [chartData6, setChartData6] = useState([]);
    const theme = useTheme();
    const { palette, spacing, shape: { borderRadius } } = useTheme()
    const [logData, setLogData] = useState([]);
    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
        LCODE: localStorage.getItem("LCODE"),
        WEB_KEY: "xyz",
        DT1: StartDate,
        DT2: EndDate,
        FID: ID
    };

    console.log("credenti", credentials)

    // ✅ Static headers (original code जैसा)
    const tableHeaders = [
        { label: "Date", key: "DT" },
        { label: "Irradiance[W/m²]", key: "RAD" },
        { label: "Power Generation[kW]", key: "POWER" },
        { label: "PR", key: "PR" },
        { label: "Expected Generation[kW]", key: "Expected_Gen" },
    ];

    // Fetch data from the API
    const fetchLogData = async () => {
        setLoading(false);
        try {
            const res = await Inverter1LogApi(credentials);


            if (res?.LOG && Array.isArray(res.LOG)) {
                // console.log("Fetched Data:", res.data);
                setLogData(res.LOG);

                // Transform the API data of Chart1
                const transformedData = res.LOG.map((item) => ({
                    time: item.DT,
                    kWh: Number(item["kWh Consumption"] || 0),
                    kVAh: Number(item["kVAh Cumulative"] || 0),
                    PF: Number(item["PF"] || 0),
                }));

                setChartData(transformedData);

                setChartData(transformedData);

                // Transform the API data of chart2
                const transformedData2 = res.LOG.map((item) => ({
                    time: item.DT,
                    kWh: Number(item["kWh Consumption"] || 0),
                    kW: Number(item.KW || 0),

                }));
                setChartData2(transformedData2);

                // Transform the API data of chart3
                const transformedData3 = res.LOG.map((item) => ({
                    time: item.DT,
                    Hz: Number(item.Hz || 0),
                    kW: Number(item.KW || 0),
                    KVA: Number(item.KVA || 0),
                }));

                setChartData3(transformedData3);



            } else {
                // console.error("Data structure mismatch:", res);
                setChartData([]); // Handle invalid data response
                setChartData2([]); // Handle invalid data response

            }
        } catch (err) {
            // console.error("Error fetching data:", err);
        }
    };

    console.log("logcred", logData)

    useEffect(() => {
        fetchLogData();
    }, []);


    // const handlePageChange = (pageNumber) => {
    //     setCurrentPage(pageNumber);
    // };



    // Handle Start Date change
    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };

    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }


    return (
        <Box bgcolor={"background.default"} py={2}>




            <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
                <Grid key="chart-grid" item xs={12}>
                    <Card>
                        <CardActions sx={{
                            display: "flex", // Enable flexbox
                            justifyContent: "flex-end", // Align items to the right
                            alignItems: "center", // Center items vertically
                            gap: "16px", // Add some spacing between the inputs
                        }}>
                            <label>
                                From:&nbsp;
                                <input
                                    type="date"
                                    value={StartDate} // Use StartDate directly
                                    onChange={(e) => handleStartDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 2px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </label>
                            <label>
                                To:&nbsp;
                                <input
                                    type="date"
                                    value={EndDate} // Use EndDate directly
                                    onChange={(e) => handleEndDateChange(e.target.value)}
                                    style={{
                                        padding: "2px 2px",
                                        borderRadius: "14px",
                                        border: "1px solid #ccc",
                                    }}
                                />
                            </label>

                            <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                            <DownloadJpegButton targetRef={chartRef} fileName={`PR-analysis[Performance].jpeg`} />
                        </CardActions>
                    </Card>
                </Grid>


            </Grid>

            <Grid ref={chartRef} container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>

                <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={12}>
                        <Card>
                            {/* Heading Box using Material UI Box */}
                            <Box
                                sx={{
                                    padding: "4px",
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                    textAlign: "start",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    border: "1px solid lightgray",

                                }}
                            >
                                <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
                                {/* Power[kW] Vs. Irradiation Curve[W/m²] */}
                               kWh Vs. kVAh Vs. PF


                            </Box>

                            <CardContent>
                                <ResponsiveContainer width="100%" height={200}>
                                    <ComposedChart data={chartData}>
                                        <CartesianGrid strokeDasharray="3 3" />

                                        <XAxis dataKey="time" />

                                        {/* Left Axis -> PF */}
                                        <YAxis
                                            yAxisId="left"
                                            label={{
                                                value: "PF",
                                                angle: -90,
                                                position: "insideLeft",
                                            }}
                                        />

                                        {/* Right Axis -> kWh & kVAh */}
                                        <YAxis
                                            yAxisId="right"
                                            orientation="right"
                                            label={{
                                                value: "kWh,kVAh",
                                                angle: 90,
                                                position: "insideRight",
                                            }}
                                            
                                        />

                                        <Tooltip />
                                        <Legend />

                                        {/* kWh */}
                                        <Bar
                                            yAxisId="right"
                                            dataKey="kWh"
                                            fill="#1c96c5"
                                            name="kWh"
                                            barSize={10}
                                        />

                                        {/* kVAh */}
                                        <Bar
                                            yAxisId="right"
                                            dataKey="kVAh"
                                            fill="#FFDE21"
                                            name="kVAh"
                                            barSize={10}
                                        />

                                        {/* PF */}
                                        <Line
                                            yAxisId="left"
                                            type="monotone"
                                            dataKey="PF"
                                            stroke="#000000"
                                            strokeWidth={3}
                                            name="PF"
                                            dot={false}
                                        />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Grid>

            <Grid ref={chartRef} container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>

                <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={12}>
                        <Card>
                            {/* Heading Box using Material UI Box */}
                            <Box
                                sx={{
                                    padding: "4px",
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                    textAlign: "start",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    border: "1px solid lightgray",

                                }}
                            >
                                <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
                                {/* Power[kW] Vs. Irradiation Curve[W/m²] */}
                                kW Vs. kWh


                            </Box>
                            <ResponsiveContainer width="100%" height={200}>
                                <ComposedChart data={chartData2}>
                                    <CartesianGrid strokeDasharray="3 3" />

                                    <XAxis dataKey="time" />

                                    {/* Left Axis -> kW */}
                                    <YAxis
                                        yAxisId="left"
                                        label={{
                                            value: "kW",
                                            angle: -90,
                                            position: "insideLeft",
                                        }}
                                    />

                                    {/* Right Axis -> kWh */}
                                    <YAxis
                                        yAxisId="right"
                                        orientation="right"
                                        label={{
                                            value: "kWh Consumption",
                                            angle: 90,
                                            position: "insideRight",
                                        }}
                                    />

                                    <Tooltip />
                                    <Legend />

                                    {/* Bar Graph -> Right Axis */}
                                    <Bar
                                        yAxisId="right"
                                        dataKey="kWh"
                                        fill="#FFDE21"
                                        name="kWh Consumption"
                                        barSize={10}
                                    />

                                    {/* Line Graph -> Left Axis */}
                                    <Line
                                        yAxisId="left"
                                        type="monotone"
                                        dataKey="kW"
                                       stroke="#000000"
                                        strokeWidth={3}
                                        name="kW"
                                        dot={false}
                                    />
                                </ComposedChart>
                            </ResponsiveContainer>
                        </Card>
                    </Grid>
                </Grid>

            </Grid>


            <Grid ref={chartRef} container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>

                <Grid container spacing={2} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid item xs={12} md={12}>
                        <Card>
                            {/* Heading Box using Material UI Box */}
                            <Box
                                sx={{
                                    padding: "4px",
                                    borderRadius: "5px",
                                    marginBottom: "15px",
                                    textAlign: "start",
                                    fontWeight: "bold",
                                    fontSize: "16px",
                                    border: "1px solid lightgray",

                                }}
                            >
                                <FaCrosshairs style={{ marginRight: "10px", color: "black" }} />
                                {/* Power[kW] Vs. Irradiation Curve[W/m²] */}
                             Demand Curve


                            </Box>
                            <CardContent>
                                <ResponsiveContainer width="100%" height={200}>
                                    <ComposedChart data={chartData3}>
                                        <CartesianGrid strokeDasharray="3 3" />

                                        <XAxis dataKey="time" />

                                        {/* Left Axis for Hz */}
                                        <YAxis
                                            yAxisId="left"
                                            label={{
                                                value: "Hz",
                                                angle: -90,
                                                position: "insideLeft",
                                            }}
                                        />

                                        {/* Right Axis for kW & KVA */}
                                        <YAxis
                                            yAxisId="right"
                                            orientation="right"
                                            label={{
                                                value: "kW / KVA",
                                                angle: 90,
                                                position: "insideRight",
                                            }}
                                        />

                                        <Tooltip />
                                        <Legend />

                                        {/* Hz Line Graph */}
                                        <Line
                                            yAxisId="left"
                                            type="monotone"
                                            dataKey="Hz"
                                            stroke="#000000"
                                            strokeWidth={3}
                                            name="Hz"
                                            dot={false}
                                        />

                                        {/* kW Bar Graph */}
                                        <Bar
                                            yAxisId="right"
                                            dataKey="kW"
                                             fill="#1c96c5"
                                            name="kW"
                                            barSize={10}
                                        />

                                        {/* KVA Bar Graph */}
                                        <Bar
                                            yAxisId="right"
                                            dataKey="KVA"
                                             fill="#FFDE21"
                                            name="KVA"
                                            barSize={10}
                                        />
                                    </ComposedChart>
                                </ResponsiveContainer>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>

            </Grid>



        </Box>
    );
};

export default SpareChart2;